import type { ModelFamily } from '../../../../../shared-pricing-config'
import type { UnifiedModel } from '../types/unified-model.types'
import { ModelFamilyIcon } from '@/shared/components/icons/ModelFamilyIcon'

const TYPE_LABELS: Record<'chat' | 'image' | 'video' | 'audio', string> = {
  chat: 'Chat',
  image: 'Image',
  video: 'Video',
  audio: 'Audio',
}

interface ModelDetailHeaderProps {
  model: UnifiedModel
  urlType: 'chat' | 'image' | 'video' | 'audio'
  provider: string
}

/** PageHero-style identity: sheen name, mono id, then type · provider meta line. */
export function ModelDetailHeader({ model, urlType, provider }: ModelDetailHeaderProps) {
  return (
    <div className="mt-6 min-w-0">
      <h1 className="pb-1 text-[clamp(2.25rem,5vw,4rem)] font-semibold leading-[0.98] tracking-[-0.05em] text-balance break-words">
        <span className="text-sheen">{model.name}</span>
      </h1>
      <p className="mt-3 truncate font-mono text-body-sm text-[var(--color-text-tertiary)]">{model.id}</p>
      <div className="mt-5 flex flex-wrap items-center gap-3 font-mono text-caption text-[var(--color-text-secondary)]">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-secondary)]">
          <ModelFamilyIcon modelFamily={model.family as ModelFamily} size={16} />
        </span>
        <span className="text-primary">{TYPE_LABELS[urlType]}</span>
        <span aria-hidden className="h-3 w-px bg-[var(--color-border-strong)]" />
        <span>by {provider}</span>
      </div>
    </div>
  )
}
